import { render, staticRenderFns } from "./distribution-chart.vue?vue&type=template&id=a1e363de&scoped=true&"
import script from "./distribution-chart.vue?vue&type=script&lang=js&"
export * from "./distribution-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e363de",
  null
  
)

export default component.exports